import React, { Fragment } from 'react';
import './UnsubscribePage.css';

export const UnsubscribePage = props => (
  <Fragment>
    <div className='content'>
      <div className='wrapper pad'>
        <h1>Traurig, aber ja.</h1>
        <p>
            Lieber McDonald&apos;s Gast, du m&ouml;chtest dich vom Newsletter
            abmelden? Schade.
        </p>
        <button
          type='submit'
          className='btn form_sub_btn'
          onClick={props.onUnsubscribe}
        >
            Abmelden
        </button>
        <br />
        <br />
        <br />
        <p id='info'></p>
      </div>
    </div>
  </Fragment>
);
